
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><div class='qnumber'>{`3`}</div>{`Wirtschaftliche Aussichten`}</h3>
    <p>{`Die kurzfristigen wirtschaftlichen Aussichten nach der Krise sind für beide Länder trüb – mit oder ohne Lockdown. Gemäss Prognosen des schwedischen `}<a parentName="p" {...{
        "href": "https://www.konj.se/english/publications/swedish-economy-report/swedish-economy/2020-05-04-updated-economic-outlook.html"
      }}>{`Konjunkturinstituts`}</a>{` und des Staatssekretariats für Wirtschaft geht im Jahr 2020 in beiden Ländern das Bruttoinlandprodukt um rund sieben Prozent zurück – allerdings gefolgt von einer Erholung im Folgejahr. `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Prognosen für 2020`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Schweden`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Schweiz`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bruttoinland`}{`­`}{`produkt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–7,0%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–6,7%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Export`}{`­`}{`wachstum`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–4%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–10,7%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Arbeits`}{`­`}{`losenquote`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10,2% (+3,4)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3,9% (+1,6)`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Schweden und die Schweiz sind stark vom Aussenhandel abhängig und reagieren empfindlich auf den Nachfragerückgang auf dem Weltmarkt. Die Prognosen für die Exporte beider Länder rechnen auch hier mit einem starken Rückgang. Bei der Beschäftigung zeichnen die Prognosen für beide Länder ein ähnliches Bild – wenn auch jeweils mit einer anderen Ausgangslage: In Schweden soll die Arbeitslosenquote von 6,8 auf 10,2 Prozent steigen, in der Schweiz von 2,3 auf 3,9 Prozent. Allerdings gehen die Experten nicht davon aus, dass sich die  Lage bereits 2021 entschärft. Sie rechnen mit einer weiteren Anstieg der Arbeitslosigkeit.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;